import { Component, OnInit } from "@angular/core";

import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { ActivatedRoute } from "@angular/router";
import { keyCloakUtilis as secureUtils} from "../utilis/si-keycloak.utilis";
import { CookieService } from "ngx-cookie";
import { SiKeycloakConfigService } from "src/app/services/si-keycloak-config.service";

@Component({
  selector: "si-keycloak-logout",
  templateUrl: "./si-keycloak-logout.component.html",
  styleUrls: ["./si-keycloak-logout.component.scss"],
})
export class SiKeyCloakLogoutComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,private cookieService : CookieService,private siAuthenticationService: SiAuthenticationService, private configService : SiKeycloakConfigService) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {

      if(params['logout']) {

        const originUrl : string = (!this.configService.getConfigByKey('cciOriginUrl')) ? window.location.origin : this.configService.getConfigByKey('cciOriginUrl');

        const keycloakLogoutUrl = this.configService.getConfigByKey('oauthLogoutUrl');
        const idToken = this.siAuthenticationService.getIDMToken();
        const postLogoutUrl = originUrl + this.configService.getConfigByKey('oauthPostLogoutCallBackUrl');
        const clientId = this.configService.getConfigByKey('oauthClientId');

        const redirectUrl = secureUtils.getKeyCloakLogoutUrl(keycloakLogoutUrl,idToken,postLogoutUrl,clientId);
      //  this.clearSessionStorage();
        window.location.href = redirectUrl;
      } else if(params['sessionLogout']) {
        
        window.location.href = `${window.location.origin}/`;

      }
    });
  }

  clearSessionStorage() : void {
      this.cookieService.removeAll();
      localStorage.clear();
  }

}
